<template>
  <v-form v-model="valid" ref="mainForm">
    <opq-case code="attestation1" v-model="sasMediationFamiliale.aspectsEconomiques" :live="liveSasMediationFamiliale(7702)"></opq-case>
    <opq-case code="attestation2" v-model="sasMediationFamiliale.aspectsPsy" :live="liveSasMediationFamiliale(7703)"></opq-case>
    <opq-case code="attestation3" v-model="sasMediationFamiliale.processusMediation" :live="liveSasMediationFamiliale(7704)"></opq-case>
    <opq-case code="attestation4" v-model="sasMediationFamiliale.sensibilisationViolenceFamiliale" :live="liveSasMediationFamiliale(7705)"></opq-case>
    <opq-file-multiple
      code="fichier-attestation-cours"
      :files="sasMediationFamiliale.attestations"
      :live="liveSasMediationFamiliale(7706)"
    ></opq-file-multiple>
  </v-form>
</template>

<script>
import FormSimple from "@/mixins/FormSimple"
export default {
  mixins: [FormSimple],
  props: {
    sas: { type: Object }
  },

  computed: {
    sasMediationFamiliale() {
      return this.sas.sasMediationFamiliale
    }
  },

  methods: {
    liveSasMediationFamiliale(cle) {
      return { endpoint: "sas-mediation-familiale", cle: cle, fileId: this.sasMediationFamiliale.id }
    }
  }
}
</script>

<style>
</style>